import { OfferingId } from '@arrived/models';

export type OfferingVideoType = string | { youtubeId: string; position: number };

export const OFFERING_VIDEOS: { [key: OfferingId]: OfferingVideoType } = {
  // The Marcelo
  171: 'sRtxW3wuQIw',
  // The Hansel
  192: 'TnnDC4etUUc',
  // The Chickamauga
  206: 'OW-4TatEaao',
  // The Litton
  210: 'oYT0RfUKsGw',
  // The Brooklyn
  212: 'RyagRyVb5TQ',
  // The Regal
  213: 'eTky8ULklEk',
  // The Lurleen
  214: 'iXT4k5VxJCY',
  // The Haven,
  215: 'b-HtMaKHHm8',
  // The Regency
  216: 'x_Z4bv0-ioQ',
  // The Sunnyside
  217: 'iXY3Cfpczcg',
  // The Korin
  218: 'Vq_c6NwTWWA',
  // The Dops
  219: 'iDAu6nyeq48',
  // The Lodge
  220: 'Th1o1wO5qMo',
  // The Chilhowee
  229: 'RQ0DK1Yrwc4',
  // The Sheezy
  230: 'SnyNUmQ3M6Q',
  // The Myrtle
  236: 'ZRz22bI5JhM',
  // The Kinlani
  237: 'Q3Hocj1Ezws',
  // The Hickorybear
  238: '5zTfvn-wlnM',
  // The Tuscarora
  241: '3fJ1XWjPSdw',
  // The Salinas
  245: '9FkkDAUNvWw',
  // The Hansard
  246: 'RkrJHB9MhNw',
  // The Jefferson
  247: '8lfSpl9zOrk',
  // The Cristalino,
  250: 'A2-IIztsdao',
  // The Koi
  256: 'YMnBkrgxOnE',
  // The Longbranch
  257: 'C-igI-5NgSs',
  // The Brookwood
  262: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
  // The Lithonia
  263: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
  // The Haverhill
  264: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
  // The Woodwind
  265: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
  // The Aspen
  266: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
  // The Thomas
  267: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
  // The Bennett
  268: {
    youtubeId: 'q1fKElqndp8',
    position: 1,
  },
};
